import { render, staticRenderFns } from "./SetupLearnPanel.vue?vue&type=template&id=6d710509"
import script from "./SetupLearnPanel.vue?vue&type=script&lang=js"
export * from "./SetupLearnPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports